import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { redirects } from '@lib/redirects';
import { Route } from '@packages/router';
import { TABS } from './List/Views/Customer/tabs';
import { ROUTES as RequestRoutes } from './Request/Router';

export const routes$ = {
    Request: RequestRoutes,
    List: AsyncPageRender(() => pageModule(import('./List'))),
    Search: AsyncPageRender(() => pageModule(import('../Apparel/Designs/List/Search'))),
    DesignId: AsyncPageRender(() => pageModule(import('../Apparel/Designs/List/DesignId'))),
};

function Router() {
    return (
        <>
            {redirects({
                '/designs/:id/view': ({ id }) => `/design/request/${id}/view`,
                '/design/list': `/design/${TABS[0]}/list`,
            })}

            <Route
                name={'Designs.List.Search'}
                exact
                path={'/design/list/search'}
                component={ProtectedRoute(routes$.Search)}
            />
            <Route
                name={'Designs.List.DesignId'}
                exact
                path={'/design/list/design-id'}
                component={ProtectedRoute(routes$.DesignId)}
            />
            <Route
                name={'Designs.AdminList'}
                exact
                path={'/design/list/:type/:tab?'}
                component={ProtectedRoute(routes$.List)}
            />
            <Route name={'Designs.List'} exact path={'/design/:tab/list'} component={ProtectedRoute(routes$.List)} />
            <Route
                name={'Designs.Request.NewView'}
                exact
                path={'/design/request/:id/new-view'}
                component={ProtectedRoute(routes$.Request.NewView)}
            />
            <Route
                name={'Designs.Request.View'}
                exact
                path={'/design/request/:id/view'}
                component={ProtectedRoute(routes$.Request.View)}
            />
            <Route
                name={'Designs.Request.Review'}
                exact
                path={'/design/request/:id/review'}
                component={ProtectedRoute(routes$.Request.Review)}
            />
            <Route
                name={'Designs.Request.Uploads'}
                exact
                path={'/design/request/:id/uploads'}
                component={ProtectedRoute(routes$.Request.Uploads)}
            />
            <Route
                name={'Designs.Request.Tip.Designer'}
                exact
                path={'/design/request/:id/tip-designer'}
                component={ProtectedRoute(routes$.Request.TipDesigner)}
            />
        </>
    );
}

export default Router;
